export type VenueAnalysisCapsuleConfigStateView =
    | 'chart'
    | 'back-historical'
    | 'back-today'
    | 'back-order';

export interface VenueAnalysisCapsuleConfigState {
    symbol?: string;
    view: VenueAnalysisCapsuleConfigStateView;
    includePreviousDaysFills?: boolean;
}

export const initialVenueAnalysisCapsuleConfigState: VenueAnalysisCapsuleConfigState =
    {
        view: 'chart',
    };
